"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuPlayButton = MenuPlayButton;
const React = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const Button_1 = require("../components/Button");
const styles_1 = require("../styles");
const useStyles = (0, styles_1.createUseThemeStyles)(() => ({
    button: {
        width: "100%",
    },
    content: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        gap: "0.75rem",
    },
    icon: {
        display: "flex",
        alignItems: "center",
        fontSize: "1.5rem",
    },
    text: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        lineHeight: 1.15,
    },
    title: {
        fontSize: "1.5rem",
    },
    subtitle: {
        fontSize: "0.8rem",
        opacity: 0.75,
    },
}));
/** The primary play call-to-action. */
function MenuPlayButton({ icon, title, subtitle, onClick, disabled, className, }) {
    const classes = useStyles();
    return (React.createElement(Button_1.Button, { color: "primary", size: "large", onClick: onClick, disabled: disabled, className: (0, classnames_1.default)(classes.button, className) },
        React.createElement("span", { className: classes.content },
            icon && React.createElement("span", { className: classes.icon }, icon),
            React.createElement("span", { className: classes.text },
                React.createElement("span", { className: classes.title }, title),
                subtitle && React.createElement("span", { className: classes.subtitle }, subtitle)))));
}
